import { v4 as uuidv4 } from 'uuid';
import ProjectImg from '../images/projectImg.png';
import UTrackerImg from '../images/utracker.png';

import CoinTrackerImg from '../images/cointracker.jpg';
import CavinImg from '../images/cavinimg.jpg';

const projects = [
  {
    id: uuidv4(),
    name: 'Blog Website',
    desc: 'An application where you create delete update and read post with authorization support',
    img: UTrackerImg,
    url: 'https://www.youtube.com/watch?v=clDlAJK8B1I.com',
  },

  {
    id: uuidv4(),
    name: 'Coin Tracker',
    desc: 'Using this app you can track any e coin. Also you will get a good advise about investment form the professional',
    img: CoinTrackerImg,
    url: '/',
  },
  {
    id: uuidv4(),
    name: "Abdul's Portfolio",
    desc: 'A portfolio for App made with React-js and Chakra UI',
    img: CavinImg,
    url: '/',
  },
  {
    id: uuidv4(),
    name: 'Tracking Soft',
    desc: 'A tracking website that will show the performance of the website. Also you will get some useful advice to improve the performance.',
    img: ProjectImg,
    url: '/',
  },
];

export default projects;
